// extracted by mini-css-extract-plugin
export default {"formNotActiveContainer":"FormNotActive_formNotActiveContainer__oNJED","formNoSelection":"FormNotActive_formNoSelection__TsDtp"};